<div class="form-group">
    <div class="d-flex">
        <div class="multiple special-file-upload width-100 with-label-icon">
            <div class="special-file-upload with-label-icon"
                [ngClass]="{'data-required':formArray.touched && formArray.invalid}">

                <label class="mgn-rigth-3 d-block">
                    {{title}} {{formArray | controlRequiredText}}
                </label>

                <i class="pj-ico pj-ico-ayuda-info text-primary" [ngClass]="{'d-none':!popoverContent}"
                    data-toggle="popover" data-placement="top" data-html="true" data-trigger="focus"
                    [attr.data-content]="popoverContent" tabindex="0">
                </i>

                <div class="pseudo-btn-file pseudo-control {{formArray.touched && formArray.invalid ? 'is-invalid': ''}}"
                    [title]="title" [innerText]="placeholder" (click)="onClickPseudoBtn($event)"
                    [ngClass]="{'d-none':dataArrayFiles.length > 0}">
                </div>

                <input #inputFile multiple type="file" (change)="onSelectFile($event)" class="file-input-upload accesibleHidden"
                    [id]="id" [accept]="format" />

                <div class="file-upload-ctn no-border" [ngClass]="{'d-none': dataArrayFiles.length === 0}">

                    <ng-container *ngFor="let e of dataArrayFiles; let i = index;">
                        <input-file-upload 
                        class="file-ctn"
                        [path]="e.path" 
                        [inProgress]="e.inProgress" 
                        [file]="e.file"
                        [id]="'pp-edit-secondary-img' + i" 
                        [type]="type"
                        (eventAddFile)="eventAddFile($event, i)"
                        (eventRemoveFile)="eventRemoveFile($event)"
                        >
                        </input-file-upload>
                    </ng-container>

                    <div [ngClass]="{'d-none': dataArrayFiles.length >= limitFiles}">
                        <button type="button" class="btn btn-sm text-primary border-color-blue"
                            title="Agregar más fotos" (click)="onClickPseudoBtn($event)">
                            <i class="pj-ico pj-ico-agregar-botones"></i>
                        </button>
                    </div>
                </div>
            </div>

            <div-validation-message [control]="formArray" [messageRequired]="messageRequired"></div-validation-message>

            <a *ngIf="modalName" role="button" class="font-size-14" (click)="onClickModalShow($event)">{{modalText}}</a>
        </div>
    </div>
</div>